import React from "react";
import { Identifiable, Project } from "@planzone/dto";

import { ZoneAvatar } from "@common/zoneAvatar";
import { Checkbox } from "../../checkbox";
import { Section } from "../../section";
import { filterSearch } from "../../utils";
import { Props } from "./types";
import { Projects } from "./projects";
import styles from "./styles.scss";

function Zone({ search, zone, filter, setFilter }: Props) {
  const isSelected =
    !!filter &&
    zone.projects.every(
      (project) => !!filter.find(({ uuid }) => uuid === project.uuid),
    );
  const selectProjects = (projects: Identifiable<Project>[]) =>
    setFilter(filter ? [...filter, ...projects] : projects);
  const unSelectProjects = (projects: Identifiable<Project>[]) =>
    filter &&
    setFilter(
      filter.filter(
        (project) => !projects.find(({ uuid }) => project.uuid === uuid),
      ),
    );

  return (
    <Section
      header={
        <div
          className={styles.header}
          onClick={() =>
            isSelected
              ? unSelectProjects(zone.projects)
              : selectProjects(zone.projects)
          }
        >
          <Checkbox isChecked={isSelected} />
          <div className={styles.icon}>
            <ZoneAvatar name={zone.name} color={zone.color} />
          </div>
          <p className={styles.name}>{zone.name}</p>
        </div>
      }
      list={
        <div className={styles.projects}>
          <Projects
            projects={filterSearch(zone.projects, search)}
            filter={filter}
            select={(project) => selectProjects([project])}
            unSelect={(project) => unSelectProjects([project])}
          />
        </div>
      }
    />
  );
}

export { Zone };
